module.exports = Vue;


//////////////////
// WEBPACK FOOTER
// external "Vue"
// module id = 18
// module chunks = 30